<template>
  <div class="time-list">
    <p>审批记录</p>
    <el-timeline>
      <el-timeline-item
          v-for="(activity, index) in activities"
          :key="index"
          :timestamp="activity.add_time">
        {{ activity.executor }}：{{activity.remark?activity.remark:'通过'}}
      </el-timeline-item>
    </el-timeline>
  </div>
</template>

<script>
import {orgShenJi} from "@/api/projectOffice";

export default {
  name: "timeList",
  props: {
    id:{
      type:Number
    },
    type:{
      type:Number
    },
    shenhe:{
      type:Number
    }
  },
  data() {
    return {
      activities: [],
    }
  },
  created() {
    this.getList()
    },
  methods:{
    async getList(){
      let _list = await orgShenJi(this.id?this.id:this.$route.query.id,this.id?this.type:7)
      this.activities = _list.data
    }
  }
}
</script>

<style scoped lang="scss">
.time-list {

  margin-left: 30px;
  width: 340px;
  padding: 30px;
  background-color: #ffffff;
  border: solid 1px #dae6f1;

  p {
    width: 90px;
    height: 20px;
    margin: 0 auto 30px;
    font-size: 18px;
    font-weight: bold;
    line-height: 30px;
    position: relative;
    text-align: center;

    &:before {
      position: absolute;
      left: -20px;
      top: 14px;
      content: '';
      width: 20px;
      height: 2px;
      background-color: #009688;
    }

    &:after {
      position: absolute;
      right: -20px;
      top: 14px;
      content: '';
      width: 20px;
      height: 2px;
      background-color: #009688;
    }
  }
}
</style>